export namespace ShrinkingHeader {
    $(function () {
        $("body").on('click', '.flyout-toggle', function () {
            $("body").toggleClass("mobile-active");
        });
    });
}